export default "__VITE_ASSET__CBikUV0d__"